var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "page_container" } }, [
    _c("div", { staticClass: "page" }, [
      _c(
        "div",
        { staticClass: "main-container", attrs: { id: "main-container" } },
        [
          _c("div", { staticClass: "successInfo" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "title" }, [_vm._v("恭喜您加入合伙人")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "button", on: { click: _vm.toGoodList } },
              [_vm._v("马上去赚钱")]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "morePro" })
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "img" }, [
      _c("img", {
        attrs: { src: require("../assets/img/common/Shape@2x.png"), alt: "" }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }